export default __webpack_public_path__ + "static/media/CrudeExtract_FR.bb3c0edd.pdf";